import { gql } from '@apollo/client';
import { GqlOrganization, GqlOrganizationFragment } from '../fragments/organization';

export interface Input {
  input: {
    divisionId: string;
    organizationId: string;
  };
}

export interface Data {
  connectDivisionToOrganization: GqlOrganization;
}

export const MUTATION = gql`
  mutation ConnectDivisionToOrganization($divisionId: ID!, $organizationId: ID!) {
    connectDivisionToOrganization(input: { divisionId: $divisionId, organizationId: $organizationId }) {
      ...OrganizationFields
    }
  }
  ${GqlOrganizationFragment}
`;
